export function isNotNullOrUndefined(value)
{
    return value !== null && value !== undefined;
}

export function isNullOrUndefined(value)
{
    return value === null || value === undefined;
}

export function isNullOrUndefinedOrEmpty(value)
{
    return isNullOrUndefined(value) || value === '';
}